{
  "DeleteReminder": "刪除提醒",
  "DismissAlert": "關閉",
  "DismissAllReminders": "關閉所有提醒",
  "DismissReminder": "關閉提醒",
  "EditReminder": "編輯提醒",
  "RemindMe15Min": "15 分鐘後再提醒我",
  "RemindMe5Min": "5 分鐘後再提醒我",
  "RemindMe60Min": "1 小時後再提醒我",
  "RemindMeTomorrow": "明天再提醒我",
  "Reminder": "提醒",
  "Reminders": "提醒",
  "Snooze": "提醒我"
}
